export default `#if defined( USE_ENVMAP )
#ifdef ENVMAP_MODE_REFRACTION
	uniform float refractionRatio;
#endif
vec3 getIBLIrradiance( const in vec3 normal ) {
	#if defined( ENVMAP_TYPE_CUBE_UV )
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );
		return PI * envMapColor.rgb * envMapIntensity;
	#else
		return vec3( 0.0 );
	#endif
}
vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
	#if defined( ENVMAP_TYPE_CUBE_UV )
		vec3 reflectVec;
		#ifdef ENVMAP_MODE_REFLECTION
			reflectVec = reflect( - viewDir, normal );
			// Mixing the reflection with the normal is more accurate and keeps rough objects from gathering light from behind their tangent plane.
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );
		#else
			reflectVec = refract( - viewDir, normal, refractionRatio );
		#endif
		reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
		vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );
		return envMapColor.rgb * envMapIntensity;
	#else
		return vec3( 0.0 );
	#endif
}
#endif
`
